import { css } from "@emotion/css";
import { tablet } from "../../styles/breakpoints";

const style = {
  container: css({
    margin: 'auto',
    marginTop: 240,
    maxWidth: 1100,
    padding: 40,
    color: "#51555C",
    fontFamily: "Inter",
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",

    h1: {
      color: "#121212",
      fontFamily: "Syne",
      fontSize: 48,
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "133.333%",
      letterSpacing: "-0.48px",
    },
    h3: {
      color: "#21243D",
      fontFamily: "Syne",
      fontSize: 25.2,
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "125%",
      marginBottom: 24,
    },
    h4: {
      color: "#717171",
      fontFamily: "Inter",
      fontSize: 20,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "150%",
      letterSpacing: 0.6,
      marginBottom: 40,
    },
    p: {
      color: "#51555C",
      fontFamily: "Inter",
      fontSize: 16,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "150%",
      marginBottom: 48,
    },

  [tablet]: {
    marginTop: 74,
    padding: 20,

    h1: {
      fontSize: 42,
    },
  }
  }),
};

export default style;
